<template>
  <div v-show="visible" class="translation-key-toggler">
    <button class="button-toggler" @click="storeConfig.toggleKeysDisplay()">
      <i class="fa fa-solid fa-language text-2xl" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useStoreConfig } from '~/store/storeConfig'
import { useDebounceFn } from '@vueuse/core'
import CookiesEnum from '~/enums/CookiesEnum'
import TtlEnum from '~/enums/TtlEnum'
import { useIdentity } from '~/store/identity'

const storeConfig = useStoreConfig()
const identity = useIdentity()

const canCheckTranslations = useCookie(CookiesEnum.CanCheckTranslations, {
  maxAge: TtlEnum.OneHour,
  default: () => '1',
  watch: 'shallow',
})

const response = await useFetch<boolean>('/api/auth/permissions/can-view-translations', {
  server: false,
})

const visible = computed(() => {
  if (response.data.value !== true) {
    canCheckTranslations.value = '0'

    return false
  }

  return true
})

useRouter().afterEach(() => {
  if (canCheckTranslations.value === '1') {
    refreshState()
  }
})

watch(
  () => identity.user,
  () => {
    refreshState()
  }
)

const refreshState = useDebounceFn(
  () => {
    response.refresh()
  },
  1000,
  { maxWait: 2000 }
)
</script>

<style lang="postcss" scoped>
.translation-key-toggler {
  @apply fixed bottom-[3.75rem] left-0 m-4 z-50;

  .button-toggler {
    @apply block px-4 py-2 border border-brand-primary bg-brand-bgLight rounded-md text-brand-primary min-w-[4rem] text-center dark:bg-dmGray5;

    @apply hover:no-underline hover:text-brand-primaryHover focus:text-brand-primaryHover;
  }
}
</style>
